import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../../pipes/pipes.module';
import { StatusBadgeModule } from '../../status-badge/status-badge.module';
import { ProcessWidgetComponent } from './process-widget.component';

@NgModule({
    declarations: [ProcessWidgetComponent],
    imports: [CommonModule, TwcModule, TranslateModule, StatusBadgeModule, PipesModule],
    exports: [ProcessWidgetComponent],
})
export class ProcessWidgetModule {}
